export default "__VITE_ASSET__CdxDII3k__"